module.exports = __webpack_public_path__ + "static/media/mouse-personalize.4017fabe.svg";